
<template>

<el-row>

    <el-row>

        <el-date-picker
          v-model="form.month"
          type="month"
          @change="onDatePickerChange"

          ref="monthPicker"
          placeholder="选择月">
        </el-date-picker>

        <employee-select @onEmployeeSelected="onEmployeeSelected" @clear="onClear" placeholder="收款人"></employee-select>

        <el-date-picker style="width:370px" v-model="form.createTime" type="datetimerange" start-placeholder="开始创建时间"  end-placeholder="结束创建时间" @change="onTimeChange">
        </el-date-picker>

        <el-input style="width:300px;" v-model="form.keyword" placeholder="商家名称/客户姓名/客户电话"></el-input>

        <el-button type="primary" @click="search()" >查询</el-button>
        <el-button type="warning" @click="exportExcel()">导出</el-button>
    </el-row>
    <el-row style="margin-top:20px;">

        <el-table :data="datas" border style="width: 100%"     tooltip-effect="dark">
            <el-table-column label="编号" width="60px">
                <template scope="scope">
                    <span>{{ scope.row.id }}</span>
                </template>
            </el-table-column>

            <el-table-column label="用户姓名" width="90px">
                <template scope="scope">
                    <span> {{ scope.row.customName }}</span>
                </template>
            </el-table-column>

            <el-table-column label="用户电话">
                <template scope="scope">
                    <span> {{scope.row.customPhone}}</span>
                </template>
            </el-table-column>

            <el-table-column label="商家信息">
                <template scope="scope">
                    <span>{{ scope.row.companyName }}</span>
                </template>
            </el-table-column>

            <el-table-column label="收款人" width="90px">
                <template scope="scope">
                    <span>{{ scope.row.payeeName}}</span>
                </template>
            </el-table-column>

            <el-table-column label="分摊月" width="90px">
                <template scope="scope">
                    <span> {{ scope.row.shareMonth}}</span>
                </template>
            </el-table-column>

            <el-table-column label="分摊收入（元）" prop="note">
              <template scope="scope">
                  <span style="color:#E6A23C;font-weight:bold;">{{scope.row.shareIncome}}</span>
              </template>
            </el-table-column>

            <el-table-column label="未分摊收入（元）" prop="note">
              <template scope="scope">
                  <span style="color:#67C23A;font-weight:bold;">{{scope.row.undistributedAmount}}</span>
              </template>
            </el-table-column>

            <el-table-column label="分摊成本（元）">
                <template scope="scope">
                    <span style="color:#E6A23C;font-weight:bold;" class=" text-nowrap">{{ scope.row.shareCost}}</span>
                </template>
            </el-table-column>

            <el-table-column label="未分摊成本（元）" prop="note">
              <template scope="scope">
                  <span style="color:#67C23A;font-weight:bold;">{{scope.row.undistributedCost}}</span>
              </template>
            </el-table-column>

            <el-table-column label="创建人">
                <template scope="scope">
                    <span class=" text-nowrap">{{ scope.row.createPeople}} - {{scope.row.createTime | dateFormat}}</span>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination style="margin-left:0px" class="row basic-margin" @size-change="fn" @current-change="fn" :current-page="currentPage" :page-size="20" layout="total, prev, pager, next, jumper" :total="total">
        </el-pagination>
    </el-row>
</el-row>

</template>

<script>

import BasicPager from '@/mixins/BasicPager'
import Config from '@/framework/configs/Config'
import BasicModel from '@/framework/basic/BasicModel'
import EmployeeSelect from '@/components/EmployeeSelect'
export default {
  name: 'free-order-management',
  extends: BasicPager,
  data: function () {
    return {
      datas: [],
      form: {
        month: null,
        goodType: null
      },
      currentPage: 1,
      total: 0,
      loading: false
    }
  },
  components: {
    EmployeeSelect
  },
  created: function () {
    this.loadList()
  },
  filters: {

    payStatusFilter: function (value) {
      // 支付状态:1-待支付；2-支付成功;3-支付失败;4-支付关闭;5-转入退款;6-取消支付;
      let str = ''
      switch (value) {
        case 1:
          str = '待支付'
          break
        case 2:
          str = '支付成功'
          break
        case 3:
          str = '支付失败'
          break
        case 4:
          str = '支付关闭'
          break
        case 5:
          str = '转入退款'
          break
        case 6:
          str = '取消支付'
          break
        case 7:
          str = '支付中'
          break
        default:
      }
      return str
    },
    goodsTypeFilter: function (value) {
      // 商品名称：1-发布二手车、2-置顶、3-联系车主、4-维保查询、5-出险查询、6-违章查询\r\n、7估价
      let str = ''
      switch (value) {
        case 1:
          str = '发布二手车'
          break
        case 2:
          str = '置顶'
          break
        case 3:
          str = '联系车主'
          break
        case 4:
          str = '维保查询'
          break
        case 5:
          str = '出险查询'
          break
        case 6:
          str = '违章查询'
          break
        case 7:
          str = '估价'
          break
        case 8:
          str = '碰撞查询'
          break
        case 9:
          str = '帖子置顶'
          break
        default:
          str = value
      }
      return str
    }

  },
  methods: {
    search: function () {
      this.currentPage = 1
      this.loadList()
    },
    onDatePickerChange: function (keyword) {
      this.loadList()
    },
    onClear: function () {
      this.form.payeeName = null
      this.loadList()
    },
    onEmployeeSelected: function (item) {
      this.form.payeeName = item.text
      this.form.payeeId = item.id
      this.loadList()
    },
    onTimeChange: function (newValue) {
      if (newValue && newValue[0] && newValue[1]) {
        this.form.startTime = newValue[0].getTime()
        this.form.endTime = newValue[1].getTime()
      } else {
        this.form.startTime = null
        this.form.endTime = null
      }
      this.loadList()
    },
    fn: function (d) {
      this.currentPage = d
      this.loadList()
    },
    loadList: function () {
      let _this = this

      let param = {
        pageNum: this.currentPage,
        pageSize: 20,
        keyword: this.form.keyword,
        goodsType: this.form.goodType,
        payStatus: this.form.payStatus,
        startTime: this.form.startTime,
        endTime: this.form.endTime,
        payeeName: this.form.payeeName

      }

      if (this.form.month) {
        let monthPicker = this.$refs['monthPicker']
        if (monthPicker && monthPicker.displayValue) {
          param.month = monthPicker.displayValue
        }
      }

      let listener = {
        success: function (dataInfo) {
          _this.datas = dataInfo.data
          _this.total = dataInfo.recordsTotal
          _this.loading = false
        }
      }
      BasicModel.get(_this, 'lcwpReceiptRecord/findLcwpReceiptShareRecordList.action', param, listener)
    },
    exportExcel: function () {
      let _this = this
      let param = {
        keyword: this.form.keyword,
        goodsType: this.form.goodType,
        payStatus: this.form.payStatus,
        startTime: this.form.startTime,
        endTime: this.form.endTime,
        payeeName: this.form.payeeName

      }

      let monthPicker = this.$refs['monthPicker']
      if (monthPicker && monthPicker.displayValue) {
        param.month = monthPicker.displayValue
      }

      let dataStr = ''

      for (var key in param) {
        if (param.hasOwnProperty(key)) {
          if (!param[key]) {
            continue
          }

          dataStr += '&' + key + '=' + param[key] + ''
        }
      }

      let userInfo = _this.getLoginInfo()
      let loginPath = userInfo.loginPath
      let id = null
      if (userInfo.id) {
        id = userInfo.id
      } else if (userInfo.employeeId) {
        id = userInfo.employeeId
      }
      window.location.href = Config.baseUrl + '/lcwpReceiptRecord/exportLcwpReceiptRecordList.action?token=' + userInfo.token + '&loginAccountId=' + id + '&loginPath=' + loginPath + dataStr
    }
  }
}

</script>
